import React, { Fragment, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import { DownOutlined, UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { RoutesService } from "../../Services";
import userServices from "../../UserServices/UserServices";

const UserBox = () => {
	const [email, setEmail] = useState("");
	const navigate = useNavigate(); // Using useNavigate for React Router v6

	const user = userServices.getCurrentUser();

	useEffect(() => {
		if (user) {
			setEmail(user.email);
		} else {
			logout();
		}
	}, [user]);

	const logout = () => {
		userServices.signOut();
		// signOut();
		navigate(RoutesService.getLoginRoute()); // Replaces history.push in React Router v6
	};

	const isBATADMIN = localStorage.getItem("role") === "BAT_ADMIN";
	const menu = (
		<Menu>
			<Menu.Item className="d-flex align-items-center" key="1" icon={<UserOutlined />}>
				{isBATADMIN ? "BAT Admin" : email}
			</Menu.Item>
			<Menu.Item className="d-flex align-items-center" key="4" icon={<LogoutOutlined />} onClick={logout}>
				Logout
			</Menu.Item>
		</Menu>
	);

	return (
		<Fragment>
			<Dropdown overlay={menu} trigger={["click"]}>
				<a href="/#" className="d-flex align-items-center text-primary ant-dropdown-link">
					<UserOutlined className="mr-2" />
					{isBATADMIN ? "BAT Admin" : email} <DownOutlined className="ml-2" />
				</a>
			</Dropdown>
		</Fragment>
	);
};

export default UserBox;
